import { Component } from "@angular/core";
import { MatDialogModule } from "@angular/material/dialog";
import { RouterOutlet } from "@angular/router";
import { LoadingSpinnerComponent } from "./shared/components/loading-spinner/loading-spinner.component";

@Component({
  selector: "app-root",
  standalone: true,
  imports: [RouterOutlet, MatDialogModule, LoadingSpinnerComponent],
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  title = "Canvassar";
}
